import { useMutation } from '@tanstack/react-query'

import { client } from '../client'
import { CLIENT_METHODS, JSONValue, ResponseData } from '../constants'

export const useApiMutation = (
  resource: string,
  requestMethod: CLIENT_METHODS.POST | CLIENT_METHODS.PATCH,
  options: Omit<any, 'mutationFn'> = {}
): ReturnType<typeof useMutation> =>
  useMutation({
    mutationFn: ({ urlParams, body }: any): Promise<ResponseData> =>
      client[requestMethod](resource, { urlParams, body } as { urlParams: JSONValue; body: JSONValue }),
    ...options,
  })
